<script>
    import {
        money, time, date, confidence, optimism,
        TimeEnum, TimeToPrint,
        modal,
        startDate,
        currentJob, currentPosition, progressTime, worked_today, days_skipped_work, stress
    } from './stores.js';
    import {JobCategories, unemployed} from "./jobs";
    import { withActionLog } from './actionLog.js';

let goToWork = () => {
    if (($days_skipped_work > 1) && ($currentJob.category !== JobCategories.Hustle)) {
        $currentJob = unemployed;
        $days_skipped_work = 0;
        $confidence -= 0.1;
        $optimism -= 0.2;
        $stress += 0.4;

        return "<h2>YOU GOT FIRED!</h2>" +
            "<br>So you think you can not show up to work for two days and then pretend like nothing happened. " +
            "Don't bother showing up here anymore!"
    } else {
        $worked_today = true;
        progressTime();
        let earnedToday = $currentJob.salary();
        $money += earnedToday
        const work_story = withActionLog(`Work: ${$currentJob.name}`, () => $currentJob.event());
        const warning = (($days_skipped_work === 1) && ($currentJob.category !== JobCategories.Hustle)) ?
            "Don't you dare skipping work again, this is your final warning! " : "";
        return warning + work_story +
            `<br>Today you earned <sl-icon src="/img/coin.svg"></sl-icon> ${earnedToday.toFixed(2)}`
    }
}

</script>

<style>
    background {
        display: block;
        min-height: 70vh;
        min-width: 40vw;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center bottom;
    }

    sl-card {
        margin: 1em;
        position: absolute;
        bottom: 1em;
        left: 1em;
        right: 1em;
    }

    sl-card [slot="footer"] {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>

<background style='background-image: url("{$currentJob.background_url}")'>

    <sl-card>
        {@html goToWork()}
        <sl-button slot="footer" type="primary" on:click="{modal.set}">Close</sl-button>
    </sl-card>
</background>
